import React from 'react'

import { ToggleFieldWithLabel } from '@components/Form/Fields'

import {
  totalContributions,
} from '@utils/assets'

import {
  totalNetExpenseAtAge,
  totalLiabilityRepaymentsAtAge,
  totalMonthlyCashflowExpensesAtAge,
} from '@utils/forecast'

import {
  totalBudgetExpensesAtAgeFromJointForecast,
} from './jointForecastCalculations'

import { R } from '@utils/currency'

export const CurrentExpenseBreakdown = ({ participantsQueries, config, jointForecast }) => {
  const tableData = participantsQueries.reduce((acc, participantQuery) => {
    const clientName = participantQuery.participant.name
    const clientId = participantQuery.participant.id
    const clientForecast = jointForecast.client_forecasts[`client_${clientId}`]

    const budgetExpenses = totalBudgetExpensesAtAgeFromJointForecast(
      jointForecast,
      participantQuery.participant.currentAge,
      {
        clientKey: `client_${participantQuery.participant.id}`,
      }
    )

    const assetContributions = totalContributions(participantQuery.assets.data, config.supportedCurrencies)
    const liabilityPayments = totalLiabilityRepaymentsAtAge(
      clientForecast,
      participantQuery.participant.currentAge
    )
    const totalExpenses = totalNetExpenseAtAge(
      clientForecast,
      participantQuery.participant.currentAge
    )

    const cashflowExpense = totalMonthlyCashflowExpensesAtAge(
      clientForecast,
      participantQuery.participant.currentAge
    )

    return {
      ...acc,
      totals: {
        budgetExpenses: acc.totals.budgetExpenses + budgetExpenses,
        assetContributions: acc.totals.assetContributions + assetContributions,
        liabilityPayments: acc.totals.liabilityPayments + liabilityPayments,
        totalExpenses: acc.totals.totalExpenses + totalExpenses,
        cashflowExpense: acc.totals.cashflowExpense + cashflowExpense
      },
      participantData: [...acc.participantData, {
        clientName,
        budgetExpenses,
        assetContributions,
        liabilityPayments,
        totalExpenses,
        cashflowExpense
      }]
    }
  },
    {
      participantData: [],
      totals: {
        budgetExpenses: 0,
        assetContributions: 0,
        liabilityPayments: 0,
        totalExpenses: 0,
        cashflowExpense: 0
      }
    })
  return (
    <>
      <ToggleFieldWithLabel
        // onChange={submitForm}
        // readOnly={readOnly}
        style={{ marginTop: '0', marginBottom: '0' }}
        label='The budget expense deficit should automatically be withdrawn from assets'
        name='withdraw_deficit'
        tooltip='Withdraw additional income from discretionary assets to cover the budget deficit for the year.'
      />
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Budget expenses</th>
            <th>Asset contributions</th>
            <th>Liability payments</th>
            <th>Total expenses</th>
          </tr>
        </thead>
        <tbody>
          {tableData.participantData.map((participantData) =>
            <tr>
              <td>{participantData.clientName}</td>
              <td>{R(participantData.budgetExpenses).format()}</td>
              <td>{R(participantData.assetContributions).format()}</td>
              <td>{R(participantData.liabilityPayments).format()}</td>
              <td>
                <span>{R(participantData.totalExpenses).format()}</span><br />
                <small>{R(participantData.cashflowExpense).format()} from cashflow expenses</small>
              </td>
            </tr>
          )}
          <tr>
            <td></td>
            <td><b>{R(tableData.totals.budgetExpenses).format()}</b></td>
            <td><b>{R(tableData.totals.assetContributions).format()}</b></td>
            <td><b>{R(tableData.totals.liabilityPayments).format()}</b></td>
            <td><b>{R(tableData.totals.totalExpenses).format()}</b></td>
          </tr>
        </tbody>
      </table>
    </>
  )
}
